export enum NotificationType {
    Announcement = 1,
    Comment,
    Reply
}